import { isRequired, isBankAccount, isInterbankAccountCode } from '@helpers/validator';

const schemaPe = {
  doc_number: {
    type: 'select',
    errorMessage: ['errors.rut.select', 'errors.rut.invalid'],
    isValid: [(value) => isRequired(value)],
  },
  interbank_account_code: {
    type: 'text',
    errorMessage: ['errors.cci.validNumber'],
    isValid: [(value) => isInterbankAccountCode(value)],
  },
  account_number: {
    type: 'text',
    errorMessage: ['errors.account.validNumber'],
    isValid: [(value) => isBankAccount(value)],
  },
};

export default schemaPe;
